import React from 'react';

import { CheckCircle2Icon, CircleIcon } from 'lucide-react';

import { cn } from '~/lib/utils';

interface FancyRadioButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'large' | 'small';
  isActive?: boolean;
  className?: string;
}

export const FancyRadioButton: React.FC<FancyRadioButtonProps> = ({
  size,
  isActive,
  children,
  className,
  ...props
}) => {
  return (
    <button
      className={cn(
        'font-greycliff-extrabold flex items-center justify-start gap-x-2 rounded-lg text-left',
        size === 'large' && 'p-6 text-lg lg:text-2xl',
        size === 'small' && 'p-4 text-xs sm:p-4 sm:text-sm',
        isActive ? 'bg-secondary text-secondary-foreground' : 'bg-secondary/10 text-secondary',
        className,
      )}
      {...props}
    >
      {isActive ? (
        <CheckCircle2Icon className='-mt-px size-4 shrink-0 sm:size-5' />
      ) : (
        <CircleIcon className='-mt-px size-4 shrink-0 sm:size-5' />
      )}
      {children}
    </button>
  );
};

FancyRadioButton.displayName = 'FancyRadioButton';
